// Styles for Breadcrumb go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledBreadcrumb = styled.div`
  .breadcrumb-link {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    align-self: stretch;
    overflow: hidden;
    max-width: 90%;
    line-height: ${toRem(18)};
    pointer-events: none;

    &:hover {
      font-weight: 500;
      user-select: none;
    }

    &.text-underline {
      text-decoration: underline;
      font-weight: 700;
      line-height: ${toRem(18)};
      pointer-events: auto;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .breadcrumb-container {
    margin: 0;
    padding-left: ${toRem(24)};
    @media ${baseVariables.mediaQuery.md} {
      padding-left: ${toRem(32)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding-left: ${toRem(24)};
    }
    @media ${baseVariables.mediaQuery.xl} {
      padding-left: ${toRem(158)};
    }
  }
`;
